// src/lib/format.js
// Phase 37 — extracted from src/App.jsx (lines 571–572, 2630, 2768, 3169–3174, 3248).
//
// Scope: pure transforms — colour brightness/darkening, size formatting, hashing.
// Public exports: darkenHex, djb2, fmtSize, isDarkColour,
//                 _dayOfYear, _hashStr, _slugifyInspire.
// Module state: none.

// True when the perceived brightness of a #rrggbb hex is low (used for
// contrast-aware label colour selection on coloured swatches).
export function isDarkColour(hex) {
  try {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return (r * 299 + g * 587 + b * 114) / 1000 < 128;
  } catch {
    return false;
  }
}

// Render mature size in metres / centimetres. Returns null for missing/invalid.
export function fmtSize(m) {
  if (!m || isNaN(m) || m <= 0) return null;
  return m < 1 ? `${Math.round(m * 100)} cm` : `${parseFloat(m.toFixed(1))} m`;
}

// Subtract `amt` from each RGB channel of a #rrggbb hex; returns rgb() string.
// Falls back to "#ccc" on parse failure.
export function darkenHex(hex, amt) {
  try {
    const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - amt);
    const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - amt);
    const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - amt);
    return `rgb(${r},${g},${b})`;
  } catch {
    return '#ccc';
  }
}

// djb2 hash — stable 32-bit string hash; identical input → identical output.
// Used to hash navigator.userAgent for tend:deviceHash (D-12 deviceChange trigger).
export function djb2(str) {
  let h = 5381;
  for (let i = 0; i < str.length; i++) {
    h = ((h << 5) + h) + str.charCodeAt(i);
    h = h | 0; // force 32-bit
  }
  return (h >>> 0).toString(36);
}

// Internal helpers exported for tests / Inspire ranking (RESEARCH Pattern A).
export function _hashStr(s) {
  let h = 0; const str = s || '';
  for (let i = 0; i < str.length; i++) { h = ((h << 5) - h) + str.charCodeAt(i); h |= 0; }
  return Math.abs(h);
}

export function _dayOfYear(d = new Date()) {
  const start = new Date(d.getFullYear(), 0, 0);
  return Math.floor((d - start) / 86400000);
}

export function _slugifyInspire(s) {
  return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}
